<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'Component_name',
  components: {
    // CustomComponent,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
  },
};
</script>

<template>
  <div :class="{ 'spinner-block': true, show }">
    <div class="spinner">
      <img :src="require('@/assets/svg/refresh.svg')" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.spinner-block {
  height: 100%;
  width: 100%;
  z-index: 100;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: -110vw;
  opacity: 0;
  pointer-events: none;

  &.show {
    position: relative;
    left: auto;
    opacity: 1;
  }
}

.spinner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  animation-name: spin;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  img {
    width: 30px;
    height: 30px;
    display: flex;
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
